<template>
  <div class="item">
    <div class="img_holder">
      <img :src="item.images[0]" />
      <router-link :to="`/${locale}/project/${item.id}`"></router-link>
    </div>
    <div class="title">
      <h3>
        <router-link :to="`/${locale}/project/${item.id}`">{{
          item.name[locale]
        }}</router-link>
      </h3>
    </div>
    <div class="view_more">
      <router-link :to="`/${locale}/project/${item.id}`">
        <span class="text">{{ $t("more") }}</span>
        <span class="arrow">
          <img src="../assets/images/arrow-r.svg" />
        </span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      locale: this.$route.params.locale
    };
  }
};
</script>
